export default __webpack_public_path__ + "static/feature_mb_03-590a01f6096c6cf3401b9ad17cd2d8f5.png";